import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AppraisifyAnalysisModule } from '../../modules/appraisifyAnalysis/AppraisifyAnalysisModule.tsx';

export const AppraisifyAnalysisRouteElement = () => (
  <ModuleContainer moduleID="appraisify-analysis" compact>
    <AppraisifyAnalysisModule />
  </ModuleContainer>
);
